import isNil from 'lodash/isNil';
import { AccessRequest } from '../entities/AccessRequest';
export function isValidAccessFormData(formData, isDataAccessRequired) {
    if (formData.assignees.length === 0) {
        return false;
    }
    return !(isDataAccessRequired && isNil(formData.dataAccess));
}
export function accessFormDataToRequests(formData, targetId, targetType, canChangeCutDataAccess) {
    const { assignees, dataAccess, recursive, message } = formData;
    if (!isValidAccessFormData(formData, canChangeCutDataAccess)) {
        return [];
    }
    return assignees.map((assignee) => {
        // 0 is default value for gem / jewelry data access
        return AccessRequest.createForAssignee(assignee, dataAccess ?? 0, recursive, message, targetId, targetType);
    });
}
export const DEFAULT_ACCESS_FORM_DATA = {
    assignees: [],
    recursive: false,
    dataAccess: undefined,
    message: '',
};
